import * as React from 'react';

export type PageVisibilityCallback = (isVisible: boolean) => void;

export function usePageVisibility(
  pageVisibilityCallback?: PageVisibilityCallback
): boolean {
  const [isVisible, setIsVisible] = React.useState(
    typeof document === 'undefined' ? true : !document.hidden
  );

  const onVisibilityChange = React.useCallback((): void => {
    const isVisible = !document.hidden;
    setIsVisible(isVisible);
    if (pageVisibilityCallback) pageVisibilityCallback(isVisible);
  }, [pageVisibilityCallback]);

  React.useEffect(() => {
    document.addEventListener('visibilitychange', onVisibilityChange, false);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [onVisibilityChange]);

  return isVisible;
}
